module.exports = __webpack_public_path__ + "img/content4-6.2481980a.png";